import { api } from './client'
import { User } from '../types'

export async function telegramAuth(initData: string): Promise<{ access_token: string }> {
  const res = await api.post('/api/v1/auth/telegram', { init_data: initData })
  return res.data
}

export async function getMe(): Promise<User> {
  const res = await api.get('/api/v1/users/me')
  return res.data
}
